import {UsuarioInformacao} from '@components/contas/UsuarioInformacao.tsx';
import {RecursoMembrosPage} from '@components/recurso/pages/RecursoMembrosPage.tsx';
import {SolicitacoesPage} from '@components/solicitacoes/pages/solicitacoes/SolicitacoesPage.tsx';
import {_SegurancaEndpoints} from '@localization/siteMap/endpoints/_SegurancaEndpoints.ts';
import {IUsuario} from '@models/conta/IUsuario.ts';
import {DefaultPageProps} from "@models/DefaultProps.ts";
import React, {useEffect, useState} from "react";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {Grid, Paper, Tab, Tabs} from "@mui/material";
import {useLocation, useNavigate, useSearchParams} from "react-router";

import {useApi} from "@contexts/hooks/api/useApi.ts";
import {UsuarioLogsPage} from "@components/usuario/pages/UsuarioLogsPage.tsx";

export interface UsuarioPageProps extends DefaultPageProps {

}

type tabs = 'InformacoesBasicas' | 'Solicitacoes' | 'RecursosMembro' | 'Logs'

export const UsuarioPage: React.FC<UsuarioPageProps> = (props) => {
    const {Get} = useApi();
    const [usuario, setUsuario] = useState<IUsuario | undefined>();
    const [refreshRequested, setRefreshRequested] = useState(false)
    const [tab, setTab] = useState<tabs>('InformacoesBasicas');
    const [serchParams] = useSearchParams();
    const location = useLocation();
    const navigate = useNavigate();

    const [usuarioId] = useState(serchParams.get('usuarioId'));

    useEffect(() => {
        if (usuarioId) {
            Get(_SegurancaEndpoints.GetContas({ids: [Number(usuarioId)]}, {
                page: 1,
                pageSize: 1
            }), refreshRequested).then(x => {
                if (x.hasData) {
                    setUsuario(x.items[0]);
                }
            }).finally(() => {
                setRefreshRequested(false)
            })
        }
    }, [usuarioId]);

    useEffect(() => {
        if (location.hash) {
            setTab(location.hash.slice(1) as tabs || 'InformacoesBasicas');
        }
    }, [location.hash]);

    return (<DefaultContainer component={Paper} {...props} size={'large'} titulo={'Usuario'}>
        {usuario && <Grid container spacing={1.5}>
            <Grid size={12}>
                <UsuarioInformacao variant={'navigationLink'} value={usuario}/>
            </Grid>
            <Grid size={12}>
                <Tabs value={tab} onChange={(_e, v) => {
                    navigate({
                        pathname: location.pathname,
                        search: location.search,
                        hash: v,
                    });
                }}>
                    <Tab value={'InformacoesBasicas'} label={'Informações Básicas'}/>
                    <Tab value={'Solicitacoes'} label={'Solicitações'}/>
                    <Tab value={'RecursosMembro'} label={'Recursos Membro'}/>
                    <Tab value={'Logs'} label={'Logs'}/>
                </Tabs>
            </Grid>
            {tab == 'InformacoesBasicas' && <Grid size={12}>
                <UsuarioInformacao variant={'grid'} value={usuario}/>
            </Grid>}
            {tab == 'Solicitacoes' && <Grid size={12}>
                <SolicitacoesPage hideHeader filtros={{usuarioCriadorId: [usuario.id]}}/>
            </Grid>}
            {tab == 'RecursosMembro' && <RecursoMembrosPage filtros={{idsMembro: [Number(usuarioId)]}}/>}
            {tab == 'Logs' && <UsuarioLogsPage filtersProps={{
                filters: {usuarioId: Number(usuarioId)}, setFilters: () => {
                }
            }}/>}
        </Grid>}
    </DefaultContainer>);
};
